import React from "react";

export default () => (
    <span className="name-outer">Utica<span className="name-inner">Shed</span>Pros</span>
);